import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import LogoQualy from '../Components/LogoQualy';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { getAuth, signInWithEmailAndPassword, browserLocalPersistence, setPersistence, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from 'react-router';

export default function PasswordReset(props) {
    const [email, setEmail] = useState("");
    const [resetButtonActive, setResetButtonActive] = useState(false);
    const [errorMessageVisible, setErrorMessageVisible] = useState(false);

    const [progress, setProgress] = useState(0);

    const auth = getAuth(props.app);

    let navigate = useNavigate();


    const startProgCountUp = (e) => {
        let countUp = 0;
        setProgress(countUp);

        setInterval(() => {
            countUp++;
            setProgress(countUp);
            if (countUp >= 100) {
                navigate('/login');
            }
        }, 100)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        resetPassword(e);
    };

    const resetPassword = async (e) => {
        sendPasswordResetEmail(auth, email)
            .then(() => {
                setResetButtonActive(true);
                startProgCountUp();
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setErrorMessageVisible(true);
                console.error(error)
            });
    };

    return (
        <Container>
            <Row className='justify-content-center'>
                <Col md={6} className='pt-5'>
                    <LogoQualy className='w-100 d-flex justify-content-center my-5' />
                    <h3 className="text-center">Trocar sua senha</h3>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicEmail" className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100" active={!resetButtonActive} hidden={resetButtonActive}>
                            Trocar senha
                        </Button>
                    </Form>
                    <Alert variant="success" hidden={!resetButtonActive} className='mt-3'>
                        <Alert.Heading>Troca de senha solicitada com sucesso</Alert.Heading>
                        <p>
                            Se seu e-mail é {email} e está cadastrado em nosso sistema. Um link de alteração de senha foi enviado.
                        </p>
                        <p>
                            Siga as instruções no e-mail para alterar sua senha.
                        </p>
                        <hr />
                        <p className="mb-2">
                            Você será redirecionado para a tela de login...
                        </p>
                        <ProgressBar animated variant='success' now={progress} />
                    </Alert>
                    <Alert variant="danger" hidden={!errorMessageVisible} className='mt-3'>
                        <Alert.Heading>Troca de senha indisponível</Alert.Heading>
                        <p>
                            Não foi possivel alterar sua senha.
                        </p>
                        <p>
                            Tente novamente mais tarde
                        </p>
                    </Alert>
                </Col>
            </Row>
        </Container>
    )
}
